import React from 'react';
import { useController } from 'react-hook-form';
import DateSelector, { IDateSelector } from './DateSelector';

type ControlledDateSelectorProps = Omit<
  IDateSelector,
  'onChange' | 'value' | 'renderInput'
>;
const ControlledDateSelector: React.FC<ControlledDateSelectorProps> = props => {
  const { name } = props;

  const {
    field,
    fieldState: { error },
  } = useController({
    name,
  });

  return <DateSelector errorMsg={error?.message} {...field} {...props} />;
};

export default ControlledDateSelector;
